import React from 'react'
import { Select, Tag } from 'antd'
import { useTranslation } from 'react-i18next'
import { Client } from '../client'
import { useAssignClientCampaign, useUnassignClientCampaign } from '../hooks'
import { useCampaigns } from '../../campaign/hooks'
import { useAuth } from '../../auth'
import { ASSIGN_CLIENT_TO_CAMPAIGN, UNASSIGN_CLIENT_FROM_CAMPAIGN } from '../../user/permission'

type Props = {
    client: Client
}

export function ClientCampaignAssign({ client }: Props) {
    const { t } = useTranslation()
    const { can } = useAuth()
    const campaignsQuery = useCampaigns({
        query: {
            size: 1000,
        },
    })
    const assignMutation = useAssignClientCampaign(client.companyId, client.userId)
    const unassignMutation = useUnassignClientCampaign(client.companyId, client.userId)

    const canAssign = can(ASSIGN_CLIENT_TO_CAMPAIGN)
    const canUnassign = can(UNASSIGN_CLIENT_FROM_CAMPAIGN)

    const assignedIds = client.assignedCampaigns.map((c) => c.id)

    if (!canAssign && !canUnassign) {
        return (
            <>
                {client.assignedCampaigns.map((campaign) => (
                    <Tag key={campaign.id}>{campaign.title}</Tag>
                ))}
            </>
        )
    }

    const handleChange = (newIds: string[]) => {
        const toAdd = newIds.filter((id) => !assignedIds.includes(id))
        const toRemove = assignedIds.filter((id) => !newIds.includes(id))

        toAdd.forEach((id) => assignMutation.mutate(id))
        toRemove.forEach((id) => unassignMutation.mutate(id))
    }

    const options = (campaignsQuery.data?.data ?? []).map((campaign) => ({
        value: campaign.id,
        label: campaign.title,
    }))

    return (
        <Select
            mode="multiple"
            value={assignedIds}
            onChange={handleChange}
            options={options}
            maxTagCount={1}
            loading={campaignsQuery.isPending || assignMutation.isPending || unassignMutation.isPending}
            placeholder={t('No campaigns')}
            style={{ width: '100%' }}
            optionFilterProp="label"
        />
    )
}
